import OsmCalculator from '@/assets/routePlanner/OsmCalculator.js';
import axios from 'axios';
import LatLngTools from '@/assets/LatLngTools.js'
import { EventBus } from '@/main.js'

const RouteCalculator = function(developerMode, map) {
	this.developerMode = developerMode || false;
	this.debugLayer = L.layerGroup();
	this.map = map;
	this.ignoreTrafficInfo = false;
	this.useTestServer = false;
	this.useTestApi = false;
  //Network bounds
	this.northEast = L.latLng(55.48274456245794, 10.589103698730469);
	this.southWest = L.latLng(55.28520130328991, 10.168511867523193);
	this.mapBounds = L.latLngBounds(this.northEast, this.southWest);

	//Bike speed
	this.speed = 4;
	this.speedArray = new Array(1.9, 1.6, 1.4, 1.2, 1.0, 0.9, 0.8, 0.7, 0.6);

	this.OsmCalculator = new OsmCalculator();
	this.osmBounds;

	//Main calculate function
	this.analyzeRoute = function(options, recalc) {
		if(recalc == undefined) {
			recalc = false;
		}
		if(this.developerMode.route) { console.log('RouteCalculator recieved options:', options); };
		//Show network bounds
		if(this.developerMode.osm && this.osmBounds == undefined) {
			this.osmBounds = L.rectangle(this.mapBounds, {color: 'blue', fillColor: 'blue', className: '', opacity: 0.5}).addTo(this.map.map);
		};

		//Check if start/end coords are within internal network coverage
		var startPointWithinNetwork = this.isWithinNetworkCoverage(options.startCoords);
		var endPointWithinNetwork = this.isWithinNetworkCoverage(options.endCoords);
		var viaPointsWithinNetwork = true;

		//console.log(options);
		//Check if via coords are within internal network coverage
		if(options.viaCoords != undefined && options.viaCoords != false && options.viaCoords.length != 0) {
			viaPointsWithinNetwork = this.isWithinNetworkCoverage(options.viaCoords);
			/*for(var i in options.viaCoords) {
				//console.log(i);
				if(options.viaCoords[i] == undefined) {
					continue;
				}

				options.viaCoords[i].isWithin = this.isWithinNetworkCoverage(options.viaCoords[i]);

				if(!options.viaCoords[i].isWithin){
					viaPointsWithinNetwork = false;
				}
			}*/
		}

		//If all points are within the network bounds
		if(startPointWithinNetwork && endPointWithinNetwork && options.viaCoords == undefined || startPointWithinNetwork && endPointWithinNetwork && viaPointsWithinNetwork) {
			return this.buildRouteObject(options, recalc);
		}
		else {
			return this.buildRouteObjectOSM(options, recalc);
		}
	};

	//Build normal route within network coverage
	this.buildRouteObject = function(options, recalc) {

		//Get raw route data from routeware
		//console.log(options);
		var alternateRoute = false;
		var data = this.calculateRoute(options, false, recalc);

		//Check for any popups to display
		if(data != undefined) {
			var popup = data.getElementsByTagName('trafikinfo');
			if(popup.length != 0) {
				if(this.developerMode.route) console.log('trafikinfo', data.getElementsByTagName('trafikinfo'));
				var message = '';

				for(var i = 0; i < popup.length; i++) {
					console.log(popup[i]);
					message += popup[i].textContent;

					if(i == 0 && popup.length > 0) {
						message += '<br><br>';
					}
				}
				EventBus.$emit('openMessageBox', {headline: '', message: message, btnText: 'Ok'});
			}
		}

		//Process data into something readable for the frontend
		if(data != undefined) {
			//Check for temp closed roads
			var alert = data.getElementsByTagName('alert')[0] || false;
			if(alert !== false) {
				if(this.developerMode.route) console.log('Alert', alert);

				var period = data.getElementsByTagName('period')[0];
				alternateRoute = {
					closedMessage: alert.textContent,
					closedPeriod: period.textContent,
					closedStart: period.getAttribute('start'),
					closedEnd: period.getAttribute('end')
				};
			}
			data = this.processRouteData(data, options);
		}
		else {
			return 'Error';
		}

		return {data: data, alternateRoute: alternateRoute};
	};

	this.findClosest = function(point, coords) {
		var latLngTools = new LatLngTools();
		var temp = [];
		for(var i in coords){
			temp.push(latLngTools.distance(point.lat, point.lng, coords[i][1], coords[i][0]));
			//this.makeCircle(coords[c], "blue");
		}
		var min = Array.min(temp);
		var nearestPoint = temp.indexOf(min);
		return nearestPoint;
	};

	//Build route using OSM networks
	this.buildRouteObjectOSM = function(options, recalc) {
		var error = false;
		var alternateRoute = false;
		var osmRoute = this.calculateRoute(options, true, recalc);
		if(osmRoute != undefined) {
			osmRoute = this.processRouteData(osmRoute, options);
			//console.log(osmRoute);
			var routePieces = [];
			var coords = osmRoute.routeCoords.geometry.coordinates;
			var routePieceWithin = this.isWithinNetworkCoverage({lat: coords[0][1], lng: coords[0][0]});
			var routePieceFirstCoords = {lat: coords[0][1], lng: coords[0][0]};

			if(options.viCoords != false) {
				var nearestPoint = this.findClosest(options.viaCoords, coords);
				//console.log(nearestPoint);
			}

			for(var i in coords) {
				var isWithin = this.isWithinNetworkCoverage({lat: coords[i][1], lng: coords[i][0]});
				if(isWithin != routePieceWithin || i == nearestPoint) {
					var linePiece = {start: {lat: routePieceFirstCoords.lat, lng: routePieceFirstCoords.lng}, end: {lat: coords[i-1][1], lng: coords[i-1][0]}, osm: isWithin};
					routePieces.push(linePiece);
					routePieceFirstCoords = {lat: coords[i][1], lng: coords[i][0]};
					routePieceWithin = isWithin;
				}
				else if(i == coords.length-1) {
					var linePiece = {start: {lat: routePieceFirstCoords.lat, lng: routePieceFirstCoords.lng}, end: {lat: coords[i][1], lng: coords[i][0]}, osm: !routePieceWithin};
					routePieces.push(linePiece);
				}
			}

			if(this.developerMode.osm) {
				console.log(routePieces);
				this.debugLayer.clearLayers();
				for(var i in routePieces) {
					var debugMarker1 = L.marker([routePieces[i].start.lat, routePieces[i].start.lng]).addTo(this.map.map);
					this.debugLayer.addLayer(debugMarker1);
					var debugMarker2 = L.marker([routePieces[i].end.lat, routePieces[i].end.lng]).addTo(this.map.map);
					this.debugLayer.addLayer(debugMarker2);
				}
				this.debugLayer.addTo(this.map.map);
			}

			var data = [];
			//console.log(options);
			for(var i in routePieces) {
				if(!error) {
					var osm = routePieces[i].osm;
					var tempOptions = {
						startCoords: {
							lat: routePieces[i].start.lat,
							lng: routePieces[i].start.lng
						},
						endCoords: {
							lat: routePieces[i].end.lat,
							lng: routePieces[i].end.lng
						},
						routeMode: options.routeMode,
						network: options.network,
						osmNetwork: options.osmNetwork,
					};

					var routeSection = this.calculateRoute(tempOptions, osm);
					if(routeSection != undefined) {
						data.push(routeSection);
					}
					else {
						error = true;
					}
				}
				else {
					break;
				}
			}
			if(!error) {
				//Glue all routes together
				data = this.OsmCalculator.glue(data);

				//Check for temp closed roads
				var alert = data.getElementsByTagName('alert')[0] || false;
				if(alert !== false) {
					if(this.developerMode.route) console.log('Alert', alert);

					var period = data.getElementsByTagName('period')[0];
					alternateRoute = {
						closedMessage: alert.textContent,
						closedPeriod: period.textContent,
						closedStart: period.getAttribute('start'),
						closedEnd: period.getAttribute('end')
					};
				}

				//Process data into something readable for the frontend
				data = this.processRouteData(data, options);

				return {data: data, alternateRoute: alternateRoute};
			}
			else {
				return 'Error';
			}
		}
		else {
			return 'Error';
		}
	};

	//Get data from routeware
	this.calculateRoute = function(options, osm, recalc) {
		var viaPoints = '';
		if(options.viaCoords != undefined && options.viaCoords != false && options.viaCoords.length != 0) {
			viaPoints += options.viaCoords.lat+','+options.viaCoords.lng;
			/*for(var i in options.viaCoords) {
				if(options.viaCoords[i] == undefined){
					continue;
				}
				viaPoints += options.viaCoords[i].lat+','+options.viaCoords[i].lng+',';
			}*/
		}
		/*for(var i in options.viaCoords) {
			if(options.viaCoords[i] == undefined){
				continue;
			}
			viaPoints += options.viaCoords[i].lat+','+options.viaCoords[i].lng+',';
		}*/
		//viaPoints = viaPoints.substring(0, viaPoints.length - 2);

		var network = osm ? options.osmNetwork : options.network;
		//Via points in order or not - r2 = inOrder - r = nonOrder - R2 might be deprecated
		if(this.ignoreTrafficInfo) {
			/*var url = 'https://apps.odenserundt.dk/r/index.php?n='+network+'&s='+options.startCoords.lat+','+options.startCoords.lng+''+
																								((viaPoints != '') ? ';'+viaPoints : '')+'&e='+options.endCoords.lat+','+options.endCoords.lng+'&routetype='+options.routeMode+((this.useTestServer) ? '&forcetest=true' : '');*/
			var url = 'https://apps.odenserundt.dk/routeplanner/rwnetservervia.php?network='+network+'&via='+options.startCoords.lat+','+options.startCoords.lng+''+
																								((viaPoints != '') ? ';'+viaPoints : '')+';'+options.endCoords.lat+','+options.endCoords.lng+'&routetype='+options.routeMode+((this.useTestServer) ? '&forcetest=true' : '');
		}
		else {
			var url = 'https://api.odenserundt.dk/'+((this.useTestApi) ? 'vdev' : 'v1')+'/route/'+network+'/'+options.startCoords.lat+','+options.startCoords.lng+''+
																							((viaPoints != '') ? ';'+viaPoints : '')+'/'+options.endCoords.lat+','+options.endCoords.lng+'/'+options.routeMode+((this.useTestServer) ? '/test' : '');
		}

		if(recalc) {
			if(this.ignoreTrafficInfo) {
				url += '&recalc=true';
			}
			else {
				url += '/recalc';
			}
		}
		var that = this;
		var result;
		var xhttp = new XMLHttpRequest();
	  xhttp.onreadystatechange = function() {
	    if (this.readyState == 4 && this.status == 200) {
				var data = this.responseXML;
				if(that.developerMode.route || that.developerMode.osm) { console.log('====================='); console.log('Success:'); console.log(network); console.log(url); console.log(data); console.log('====================='); }
				
				//Error in data
				if(data == null || data == undefined || data.getElementsByTagName('Name').length == 0) {
					var error = data.createElement('error');
					data.getElementsByTagName("p")[0].appendChild(error);
					return false;
				}

				result = data;
	    }
	  };
	  xhttp.open("GET", url, false);
	  xhttp.send();

		return result;

		/*axios.get(url)
		.then(response => {
	    //console.log(response);
			var parser = new DOMParser();
			var data = parser.parseFromString(response.data, 'text/xml');
			//Debug
			if(this.developerMode.route || this.developerMode.osm) { console.log('====================='); console.log('Success:'); console.log(network); console.log(url); console.log(data); console.log('====================='); }

			//Error in data
			if(data == null || data == undefined || data.getElementsByTagName('Name').length == 0) {
				console.log('error', url);
				var error = data.createElement('error');
				data.getElementsByTagName("p")[0].appendChild(error);
				return false;
			}
			//return response.responseXML;
			return data;
	  })
	  .catch(error => {
	    console.log(error);
			if(this.developerMode.route) { console.log('====================='); console.log('Route Failure:');	console.log(network);	console.log(url); console.log('====================='); }
			return false;
	  });*/
	}

	//Process Route data into something usefull
	this.processRouteData = function(data, routeOptions) {
		var c = '';
		var steps = data.querySelectorAll('_SHAPE_');
		var name = data.getElementsByTagName('Name');
		var distance = data.getElementsByTagName('Dist');
		var totalDistance = data.getElementsByTagName('TotalDist');
		var totalTime = data.getElementsByTagName('TotalTime');
		var turn = data.getElementsByTagName('Turn');
		var firstPoint = true;
		var viaPointSaved = false;
		var firstCoords = [];
		var simpleDescription = new Array();
		var fullDistance  = (Math.round(totalDistance[name.length - 1].textContent * 10 ) / 10);
		var totalTimeAdjusted = 0;

		//Adjust route speed if bike
		if(routeOptions != undefined && routeOptions.type == 'bike') {
			if(app.loggedIn && app.userData.userData.cycleSpeed && app.userData.userData.cycleSpeed != undefined) {
				this.speed = parseInt(app.userData.userData.cycleSpeed);
			}
			else {
				this.speed = 4;
			}
			totalTimeAdjusted = Math.ceil(totalTime[name.length - 1].textContent);

			totalTimeAdjusted = Math.ceil(totalTimeAdjusted * this.speedArray[this.speed]);
		}
		else {
			totalTimeAdjusted = Math.ceil(totalTime[name.length - 1].textContent);
		}

		var viaIndex = false;

		simpleDescription.push('Start på '+name[1].textContent);

		for(var i = 0; i < name.length; i++) {
			var skipStep = false;
			if(name[i].textContent == 'Start' || name[i].textContent == 'End') {
				continue;
			}

			var rt = steps[i].querySelectorAll('coordinates');

			if(rt.length == 0) {
				continue;
			}

			//var rie = rt.context.textContent || rt.context.text;
			if(rt[0] == undefined){
				var rie = rt.context.textContent;
			}
			else{
				var rie = rt[0].textContent;
			}

			if(rie != '' && rie != undefined){

				var r = rie.split(' ');

				var meter = parseInt(distance[i].textContent * 1000);

				meter = ((meter < 1000) ? meter+' m' : (Math.round((meter / 1000) * 10) / 10) + ' km');

				//-2 equals a via point
				if(turn[i].textContent == -2) {
					if(name[i + 1].textContent == 'Via' && routeOptions.simpleRoute != true) {
						simpleDescription.push('Du er ankommet til dit viapunkt');
						viaPointSaved = true;
						//continue;
						viaIndex = i;
					}
					else {
						//If used to calculate a simple route for "Turforslag" ignore via points
						if(routeOptions.simpleRoute != undefined && routeOptions.simpleRoute) {
							simpleDescription.push('SKIPTHIS');
						}
						else {
							simpleDescription.push('Efter '+meter+': Fortsæt lige ud ad '+name[i+1].textContent);
						}
					}
				}
				else if(turn[i].textContent >= 0 && turn[i].textContent <= 22) {
					simpleDescription.push('Efter '+meter+': Fortsæt lige ud ad '+name[i+1].textContent);
				}
				else if(turn[i].textContent >= 23 && turn[i].textContent <= 67) {
					simpleDescription.push('Efter '+meter+': Lille sving til venstre ad '+name[i+1].textContent);
				}
				else if(turn[i].textContent >= 68 && turn[i].textContent <= 112) {
					if(turn[i+1].textContent >= 68 && turn[i+1].textContent <= 112 && parseInt(distance[i+1].textContent * 1000) < 20/* && (name[i].textContent == name[i+1].textContent)*/) {
						//console.log('U-TURN');
						// U-vending.
						simpleDescription.push('Efter '+meter+': Foretag en u-vending ved '+name[i+1].textContent);
					}
					if(i != 0 && turn[i-1].textContent >= 68 && turn[i-1].textContent <= 112 && parseInt(distance[i+1].textContent * 1000) < 20/* && (name[i].textContent == name[i-1].textContent)*/) {
						// Spring over, sidste var et venstre sving.
						//console.log('SKIP');
						skipStep = true;
					}
					else {
						simpleDescription.push('Efter '+meter+': Drej til venstre ad '+name[i+1].textContent);
					}
				}
				else if(turn[i].textContent >= 113 && turn[i].textContent <= 157) {
					simpleDescription.push('Efter '+meter+': Skarpt sving til venstre ad '+name[i+1].textContent);
				}
				else if(turn[i].textContent >= 158 && turn[i].textContent <= 202) {
					simpleDescription.push('U-sving');
				}
				else if(turn[i].textContent >= 203 && turn[i].textContent <= 247) {
					simpleDescription.push('Efter '+meter+': Skarpt sving til højre ad '+name[i+1].textContent);
				}
				else if(turn[i].textContent >= 248 && turn[i].textContent <= 292) {
					simpleDescription.push('Efter '+meter+': Drej til højre ad '+name[i+1].textContent);
				}
				else if(turn[i].textContent >= 293 && turn[i].textContent <= 337) {
					simpleDescription.push('Efter '+meter+': Lille sving til højre ad '+name[i+1].textContent);
				}
				else if(turn[i].textContent >= 338 && turn[i].textContent <= 359) {
					simpleDescription.push('Efter '+meter+': Fortsæt lige ud ad '+name[i+1].textContent);
				}
				else if(turn[i].textContent > 360) {
					simpleDescription.push('Efter '+meter+': Tag udkørsel nr. '+(turn[i].textContent - 360)+' i rundkørslen og fortsæt ad ' + name[i+1].textContent);
				}

				for(var a = 0; a < r.length; a++) {
					/* Start point */
					if(firstPoint) {
						if(r[a] != undefined) {
							var startCoords = r[a].split(',');
							firstPoint = false;
						}
					}

					// First point of every linepiece
					if(a == 0) {
						var coords = r[a].split(',');
						coords[0] = parseFloat(coords[0]);
						coords[1] = parseFloat(coords[1]);
						var center = coords.reverse();
						if(!skipStep) firstCoords.push(center);
					}

					/* End point */
					if(a == r.length - 1) {
						var endCoords = r[a - 1].split(',');
					}

					if(r[a] != '' && r[a+1] != undefined) {
						c += r[a] + '],[';
					}
				}
			}
		}

		var firstEnd = [parseFloat(endCoords[1]), parseFloat(endCoords[0])];
		firstCoords.push(firstEnd);

		/* Endpoint description */
		simpleDescription.push('Efter '+fullDistance+' km: Du er ankommet til din destination');

		var route = '{"type":"Feature","properties": {"name": "rute"}, "geometry": {"type": "LineString","coordinates":[['+c+']]';
		route = route.substring(0, route.length - 4);
		route += ']}}';

		route = JSON.parse(route);

		this.pointsLength = route.geometry.coordinates.length;
		this.pointsList = route.geometry.coordinates;

		/*var m_via = false;

		if(this.coords.via != undefined && this.coords.via.lat != undefined && this.coords.via.lng != undefined){
			m_via = [this.coords.via.lng, this.coords.via.lat];
		}

		if(!!viaIndex){
			if(turn[viaIndex + 1]).text() == 180){
				var containsUTurn = true;
			}
			else{
				var containsUTurn = false;
			}
		}*/
		var values = {
			routeCoords: route,
			startCoords: startCoords,
			endCoords: endCoords,
			//viacoords: this.getViaCoords(),
			simpleDescription: simpleDescription,
			km: fullDistance,
			time: totalTimeAdjusted,
			//error: error,
			firstCoords: firstCoords,
			speed: this.speed,
			pointsLength: this.pointsLength,
			pointsList: this.pointsList,
			closed: this.routeIsClosed,
			//containsUTurn: containsUTurn
		}

		return values;
	};

	//OSM coord checker
  this.isWithinNetworkCoverage = function(coords) {
		return this.mapBounds.contains([parseFloat(coords.lat), parseFloat(coords.lng)]);
  };

	//Used
	this.createSimpleRoute = function(id, onErr) {
		if(window["app"] != undefined){
			app.calculatingRoute = true;
		}

		var startpoint, viapoint, endpoint, n;

		onErr = onErr || false;

		var c = '';
		var error = 'none';
		var values;

		// check if id is an int
		if(!isNaN(id) && parseInt(Number(id)) == id && !isNaN(parseInt(id, 10))){
			var url = "https://apps.odenserundt.dk/data/rawroutedata/"+id+".xml";
		}
		// if it's no and int, it's an object containing coordinates
		// (at the momoent only used for printing)
		else{
			var n = id.network;
			var url = generateURLForSimpleRoute(id);
			console.log(id);
			console.log(url);
		}

		var that = this;
		var result;
		var xhttp = new XMLHttpRequest();
	  xhttp.onreadystatechange = function() {
	    if (this.readyState == 4 && this.status == 200) {
				values = that.processRouteData(this.responseXML, {simpleRoute: true});
	    }
	  };
	  xhttp.open("GET", url, false);
	  xhttp.send();

		/*$.ajax({
		type: "GET",
			url: url,
			dataType: "xml",
			timeout: 10000,
			async: false,
			error: function(){
				if(!!onErr){
					onErr();
				}
			}
		})
		.done(function(data) {
			var options = {simpleRoute: true};
			values = that.processRouteData(data, options);
		});*/
		return values;
	};
};

export default RouteCalculator;
